/*
 *   File : digital-esign.js
 *   Author URI : https://evoqins.com
 *   Description : Esign.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";

import { GradientButton } from "../../../Component/CTA";
import APIService from "../../../Service/api-service";
import { _getKycProfile } from "../../../Helper/api";
import { useNavigate } from "react-router-dom";
import AcceptConsent from "../../../Component/Modal/consent";
import { Modal } from "bootstrap";

export default function DigitalEsign(props) {
    const navigate = useNavigate();
    const [apiLoader, setApiLoader] = useState(false);
    const [showConsent, setShowConsent] = useState(false);

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     const status = params.get("status"); // success / failure
    //     if (status) {
    //         navigate("/kyc")
    //         _digiLockerCallback();
    //     }
    // }, []);

    useEffect(() => {
        if (showConsent === true) {
            const modal = new Modal(document.getElementById("consent"), {});
            modal.show();
        }
    }, [showConsent])

    // API - initiate digilocker to complete kyc
    const _handleProceed = () => {
        setApiLoader(true);
        let url = props.is_manual ? "kyc/esign/initiate-agreement" : 'kyc/esign/initiate';
        APIService(false, url, "access", null, props.is_manual ? false : true).then((response) => {
            if (response.status_code === 200) {
                _initiateDigiLocker(response.data.id, response.data.signing_parties[0].identifier, response.data.access_token.id);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
                setApiLoader(false);
            }
        })
    };

    // open digilocker UI to enter aadhar number
    async function _initiateDigiLocker(digiLockerId, mail, token_id = Cookies.get("digio_token")) {
        // var Digio = await window.Digio;
        // var options = {
        //     // "environment" : "process.env.REACT_APP_DIGILOCKER_ENVIRONMENT", 
        //     "environment":process.env.REACT_APP_DIGILOCKER_ENVIRONMENT,
        //     "callback": _digiLockerCallback,
        //     "logo": process.env.REACT_APP_LOGO
        // };

        // var digio = new Digio(options);

        // try {
        //     digio.init();  // Call init on user action (eg.button press) and then proceed to asynchronous upload
        //     digio.submit(digiLockerId, mail, token_id);
        // } catch (err) {
        //     // console.log(err)
        //     this.notify("Allow pop-ups and reload the page to fetch from digilocker. ")
        // }
        try {
            // Use sandbox/test URL
            const baseUrl = process.env.REACT_APP_DIGILOCKER_ENVIRONMENT === "production" ? "https://app.digio.in/#/gateway/login" : "https://ext-gateway.digio.in/#/gateway/login"

            const sdkver = "11.0";
            const method = "otp";
            const redirect_timeout = 2800;

            const theme = encodeURIComponent(
                JSON.stringify({
                    PRIMARY_COLOR: "#2979BF",
                    FONT_FAMILY: "",
                    FONT_URL: "",
                    FONT_FORMAT: "",
                })
            );

            const redirectUrl = encodeURIComponent(
                window.location.origin + `/digio-callback?verification-type=esign&is_manual=${props.is_manual}`
            );

            const url = `${baseUrl}/${digiLockerId}/${token_id}/${mail}?token_id=${token_id}&sdkver=${sdkver}&method=${method}&redirect_timeout=${redirect_timeout}&theme=${theme}&redirect_url=${redirectUrl}`;

            // Open in a new tab / page
            window.location.href = (url);
        } catch (err) {
            console.error("Unable to open DigiLocker page", err);
        }
    }

    const _nextStep = async () => {
        const kyc_data = await _getKycProfile();
        setApiLoader(false);
        props.updateProgress(8, props.text, props.is_manual)
    }
    return (
        <div className="row">
            <div className="col-12" >
                <h2 className="color-black e-inter-bold e-font-24 mb-2">
                    Digital signature required for HUF investment account
                </h2>
                <p className="color-outer-space e-poppins-regular e-font-16 mb-3">
                    To proceed with the creation of your HUF Non-Individual Investment Account, we require your Karta's e-signature verification and authorization.
                </p>
                <p className="color-outer-space e-poppins-medium e-font-16 mb-2">Ensure that the details provided match your submitted KYC documents.</p>
                <p className="color-outer-space e-poppins-medium e-font-16 mb-0">This step is essential for secure and seamless account activation.</p>
                <GradientButton label="Proceed to E-Sign"
                    className="px-3 padding-12px-tb e-font-16 margin-40px-top"
                    loading={apiLoader}
                    handleClick={() => setShowConsent(true)} />
                {
                    showConsent === true &&
                    <AcceptConsent accept={_handleProceed}
                        close={() => setShowConsent(false)} />
                }
            </div>
        </div>
    )
}
